import * as React from "react";
import {
  Chart,
  ArgumentAxis,
  ValueAxis,
  BarSeries,
  ChartProps,
  Tooltip,
} from "@devexpress/dx-react-chart-material-ui";
import { Stack, Animation, EventTracker, HoverState } from "@devexpress/dx-react-chart";

import { useTheme } from "@mui/material";
import { formatPrice } from "helpers/dataFormat";

const makeLabel =
  (symbol: string, color: string) =>
  ({ text, style, ...restProps }: any) =>
    <ValueAxis.Label text={`${text}`} style={{ ...style }} {...restProps} />;

const PriceLabel = makeLabel("$", "#fcd45a");

const ArgumentLabel = (props: any, selectOption: string) => {
  return <ArgumentAxis.Label {...props} text={selectOption === "lastMonth" ? "" : props.text} />;
};

const BarComponent = (props: BarSeries.PointProps) => {
  return <BarSeries.Point {...props} rx={2} />;
};

const BarChart = ({
  height,
  data,
  selectOption,
}: {
  height?: number;
  data: BarChartDataType;
  selectOption: string;
}) => {
  const ChartWithChildren = Chart as React.ComponentType<ChartProps & { children: React.ReactNode }>;

  const {
    palette: {
      primary: { main },
    },
  } = useTheme();

  const [hover, setHover] = React.useState(undefined);
  // const [selection, setSection] = React.useState(undefined);

  const clickItem = ({ targets }: any) => {
    const target = targets[0];
    // if (target) setSection(targets);
  };

  const changeHover = (hover: any) => {
    // setHover(hover);
  };

  const renderTooltip = (props: any, data: any) => {
    data = props.targetItem ? data[props.targetItem.point] : null;
    return (
      <div style={{ direction: "rtl" }}>
        <div>{data.title}</div>
        {props.targetItem?.series === "Income" && <div>درآمد {formatPrice(data.income)}</div>}
        {props.targetItem?.series === "Cost" && <div>هزینه {formatPrice(data.cost)}</div>}
      </div>
    );
  };

  return (
    <div style={{ direction: "ltr" }}>
      <ChartWithChildren data={data} height={height || 350}>
        <ArgumentAxis labelComponent={(props) => ArgumentLabel(props, selectOption)} />
        {/*<ValueAxis showGrid={false} labelComponent={PriceLabel} />*/}
        <BarSeries
          name="Income"
          valueField="income"
          argumentField="title"
          pointComponent={BarComponent}
          barWidth={0.8}
          color={main}
        />
        <BarSeries
          name="Cost"
          valueField="cost"
          argumentField="title"
          barWidth={0.8}
          pointComponent={BarComponent}
          color="#0a345223"
        />
        {/*<Animation />*/}
        <Stack />
        <EventTracker onClick={clickItem} />
        <HoverState hover={hover} onHoverChange={changeHover} />
        <Tooltip targetItem={hover} contentComponent={(props) => renderTooltip(props, data)} />
      </ChartWithChildren>
    </div>
  );
};

export default BarChart;
